import { loadGoogleAnalytics } from './loadGoogleAnalytics';
import { loadClarity } from './loadClarity';

/**
 * Bridges the app's existing internal event bus (analyticsService.js's
 * track() — already called from ~20 places: checkout steps, cart
 * abandonment, coupon usage, product views, download access, etc.) to
 * GA4 and Clarity. Before this, track() only dispatched a DOM CustomEvent
 * that nothing listened to — none of those events actually reached any
 * analytics provider.
 */
const bridgeInternalEvents = () => {
  window.addEventListener('nls:analytics', (e) => {
    const { event, ...params } = e.detail || {};
    if (!event) return;

    if (window.gtag) {
      window.gtag('event', event, params);
    }
    if (window.clarity) {
      window.clarity('event', event);
    }
  });
};

/**
 * Call once at app bootstrap (client/src/index.js). Production-only by
 * design — local dev must never send real traffic into these properties.
 * Each provider is independently optional: set only REACT_APP_GA_
 * MEASUREMENT_ID, only REACT_APP_CLARITY_PROJECT_ID, both, or neither.
 */
export const initAnalytics = () => {
  if (process.env.NODE_ENV !== 'production') return;

  loadGoogleAnalytics(process.env.REACT_APP_GA_MEASUREMENT_ID);
  loadClarity(process.env.REACT_APP_CLARITY_PROJECT_ID);
  bridgeInternalEvents();
};
